/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import { createMedia } from '@artsy/fresnel'
import PropTypes from 'prop-types'
import React, {  useState, useEffect } from 'react'
import { InView } from 'react-intersection-observer'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Label,
  Tab,
  Card,
  Embed,
  Message,
} from 'semantic-ui-react'
import { QCMarkdown } from './components/Text'
import conf from './conf'

const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
})

const HomepageHeading = ({ mobile, available, logIn }) => {
  return (
    <Container text>
      <Button as='a' labelPosition='right' style={{ marginTop: '1em' }}>
        <Button basic color='red' as='a'>
          <Icon name='winner' />
          Winner
        </Button>
        <Label as='a' basic color='blue' pointing='left'>
          <a
            href="https://womanium.org/Quantum/Program"
            target="_blank"
            rel="noopener noreferrer"
          >
            Womanium Global Quantum Project
            {' '}
            <Icon name='external alternate' />
          </a>
        </Label>
      </Button>
      <Image alt="logo" style={{height: '300px'}} src='/images/logo512x450.png' centered />
      <Header
        as='h1'
        style={{
          fontSize: mobile ? '2em' : '4em',
          fontWeight: 'normal',
          marginTop: mobile ? '0' : '0',
        }}
      >
        <span style={{color: 'gray'}}>⟨</span>
        <span style={{color: 'red'}}>Quantum</span>
        <span style={{color: 'gray'}}>|</span>
        <span style={{color: 'royalblue'}}>Copilot</span>
        <span style={{color: 'gray'}}>⟩</span>
      </Header>
      <Header
        as='h2'
        style={{
          fontSize: mobile ? '1.1em' : '2.2em',
          fontWeight: 'normal',
          marginTop: mobile ? '0.25em' : '0.5em',
          marginBottom: '2em',
        }}
      >
        <span style={{color: 'dimgray'}}>AI-Assisted Quantum Computing</span>
      </Header>
      <Button
        style={{
          marginBottom: '5em',
        }}
        primary size='huge' onClick={() => logIn(false)}
      >
        { available ? 'Chat to Quantum' : 'Join a Whitelist' }
        <Icon name='right arrow' />
      </Button>
    </Container>
  )
}

HomepageHeading.propTypes = {
  mobile: PropTypes.bool,
  available: PropTypes.bool.isRequired,
  logIn: PropTypes.func.isRequired,
}

const DesktopContainer = ({ children, available, logIn }) => {
  const [ fixed, setFixed ] = useState(false)

  return (
    <Media greaterThan='mobile'>
      <InView onChange={(inView) => setFixed(!inView)}>
        <Segment
          textAlign='center'
          style={{ minHeight: 700, padding: '1em 0em' }}
        >
          <Menu
            fixed={fixed ? 'top' : null}
            pointing={!fixed}
            secondary={!fixed}
            size='large'
          >
            <Container>
              <Menu.Item active>
                <Image avatar alt="logo" src='/images/logo192.png' />
                <Link to='/'> {' '} Home</Link>
              </Menu.Item>
              <Menu.Item position='right'>
                { available ? (
                  <>
                    <Button as='a' onClick={() => logIn(true)} >
                      Log In
                    </Button>
                    <Button as='a' primary={fixed} style={{ marginLeft: '0.5em' }} onClick={() => logIn(false)} >
                      Sign up
                    </Button>
                  </>
                ) : (
                  <Button onClick={logIn}>
                    Join a Whitelist
                  </Button>
                )}
              </Menu.Item>
            </Container>
          </Menu>
          <HomepageHeading available={available} logIn={logIn}/>
        </Segment>
      </InView>

      {children}
    </Media>
  )
}

DesktopContainer.propTypes = {
  children: PropTypes.node,
  available: PropTypes.bool.isRequired,
  logIn: PropTypes.func.isRequired,
}

const MobileContainer = ({ children, available, logIn }) => {
  const [ sidebarOpened, setSidebarOpened ] = useState(false)

  return (
    <Media as={Sidebar.Pushable} at='mobile'>
      <Sidebar.Pushable>
        <Sidebar
          as={Menu}
          animation='overlay'
          onHide={() => setSidebarOpened(false)}
          vertical
          visible={sidebarOpened}
        >
          <Menu.Item active>
            <Link to='/'>Home</Link>
          </Menu.Item>
          { available ? (
            <>
              <Menu.Item as='a' onClick={() => logIn(true)}>
                Log In
              </Menu.Item>
              <Menu.Item as='a' onClick={() => logIn(false)}>
                Sign up
              </Menu.Item>
            </>
          ) : (
            <Menu.Item onClick={() => logIn(false)}>
              { available ? 'Get Started' : 'Join a Whitelist' }
            </Menu.Item>
          )}
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarOpened}>
          <Segment
            textAlign='center'
            style={{ minHeight: 350, padding: '1em 0em' }}
            vertical
          >
            <Container>
              <Menu pointing secondary size='large'>
                <Menu.Item onClick={() => setSidebarOpened(true)}>
                  <Icon name='sidebar' />
                </Menu.Item>
                <Menu.Item position='right'>
                  { available ? (
                    <>
                      <Button as='a' onClick={() => logIn(true)}>
                        { available ? 'Log In' : 'Join a Whilelist' }
                      </Button>
                      <Button as='a' style={{ marginLeft: '0.5em' }} onClick={() => logIn(false)}>
                        { available ? 'Sign up': 'Join a Whitelist' }
                      </Button>
                    </>
                  ) : (
                    <Button onClick={logIn}>
                      Join a Whitelist
                    </Button>
                  ) }
                </Menu.Item>
              </Menu>
            </Container>
            <HomepageHeading mobile available={available} logIn={logIn}/>
          </Segment>

          {children}
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    </Media>
  )
}

MobileContainer.propTypes = {
  children: PropTypes.node,
  available: PropTypes.bool.isRequired,
  logIn: PropTypes.func.isRequired,
}

const ResponsiveContainer = ({ children, available, logIn }) => (
  /* Heads up!
   * For large applications it may not be best option to put all page into these containers at
   * they will be rendered twice for SSR.
   */
  <MediaContextProvider>
    <DesktopContainer available={available} logIn={logIn}>{children}</DesktopContainer>
    <MobileContainer available={available} logIn={logIn}>{children}</MobileContainer>
  </MediaContextProvider>
)

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
  available: PropTypes.bool,
  logIn: PropTypes.func,
}

const HomepageLayout = () => {
  const navigate = useNavigate()
  const [available, setAvailable] = useState(true)

  const logIn = (openLogin) => {
    if (available) {
      // navigate('/chat')
      if (openLogin) {
        navigate('/login')
      } else {
        navigate('/signup')
      }
    } else {
      console.log('navigate to interestForm')
      window.open(conf.interestForm.url, '_blank')
    }
  }

  useEffect(() => {
    // Run only once
    axios.get(`${conf.api.url}/available`)
      .then((response) => {
        if (response.data.status === 'available') {
          console.log('The API is available. You can log in.')
        } else {
          console.warn('Unknown availability status. Join a Whitelist.')
          setAvailable(false)
        }
      })
      .catch(function (error) {
        console.error('error:', error);
        console.warn('The API is unavailable. Join a Whitelist.')
        setAvailable(false)
      })
  }, []);

  return (
    <ResponsiveContainer logIn={logIn} available={available}>

      <Segment style={{ padding: '8em 0em' }} vertical>
        <Grid container stackable verticalAlign='middle'>
          <Grid.Row>
            <Grid.Column floated='left' width={6}>
              <Image bordered rounded size='large' src='/images/quantum-girl.png' />
            </Grid.Column>
            <Grid.Column floated='right' width={8}>
              <Header as='h3' style={{ fontSize: '2em' }}>
                We Help People with Quantum
              </Header>
              <p style={{ fontSize: '1.33em' }}>
                Quantum computing is the future of computing, and ⟨Quantum|Copilot⟩ is the perfect tool for anyone who wants to learn quantum technologies.
                The AI assistant helps quantum computing enthusiasts and professionals program quantum computers.
              </p>

              <Header as='h3' style={{ fontSize: '1.5em' }}>
                Program Quantum Computers in Plain Language
              </Header>
              <p style={{ fontSize: '1.33em' }}>
                <ul>
                  <li>
                    Ask any question about quantum computing and get an expert answer in seconds.
                  </li>
                  <li>
                    Generate code of quantum algorithms and draw quantum circuits.
                  </li>
                  <li>
                    Convert quantum code between various quantum programming languages and libraries.
                  </li>
                  <li>
                    Stay up-to-date on the latest developments in quantum computing.
                  </li>
                  <li>
                    Run quantum programs on quantum simulators or on real quantum hardware.
                  </li>
                </ul>
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column floated='left' width={6}>
              <Header as='h3' style={{ fontSize: '2em' }}>
                Conversational AI
              </Header>
              <p style={{ fontSize: '1.33em' }}>
                We develop universal conversational user interface for any quantum computers.
              </p>
              <p style={{ fontSize: '1.33em' }}>
                ⟨Quantum|Copilot⟩ is powered by the latest advances in artificial intelligence and large language models. This means that it can understand your questions and provide you with accurate and helpful answers, even if they are complex or open-ended.
              </p>
              <p style={{ fontSize: '1.33em' }}>
                Whether you are a beginner or an experienced quantum computing developer, ⟨Quantum|Copilot⟩ can help you take your skills to the next level.
              </p>
            </Grid.Column>
            <Grid.Column floated='right' width={6}>
              <Image bordered rounded size='large' src='/images/schrodingers-cat.png' />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign='center'>
              <Button size='huge' onClick={() => logIn(false)}>
                { available ? 'Get Started' : 'Join a Whitelist' }
                <Icon name='right arrow' />
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>

      <Segment style={{ padding: '0em' }} vertical>
        <Grid celled='internally' columns='equal' stackable>
          <Grid.Row textAlign='center'>
            <Grid.Column style={{ paddingBottom: '5em', paddingTop: '5em' }}>
              <Header as='h4' style={{ fontSize: '1.5em' }}>
                "I am a beginner in quantum computing software development, but I found Quantum Copilot to be very helpful. I was able to learn the basics quickly and easily."
              </Header>
              <p style={{ fontSize: '1.33em' }}>
                <Image avatar src='/images/software-engineer.png' />
                - John Smith, Software Engineer
              </p>
            </Grid.Column>
            <Grid.Column style={{ paddingBottom: '5em', paddingTop: '5em' }}>
              <Header as='h4' style={{ fontSize: '1.5em' }}>
                "I am an experienced quantum computing researcher, and I found Quantum Copilot to be a valuable resource. It has helped me to stay up-to-date on the latest developments in the field."
              </Header>
              <p style={{ fontSize: '1.33em' }}>
                <Image avatar src='/images/professor-physics.png' />
                - Jane Doe, Professor of Physics
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>

      <Card.Group centered style={{ padding: '6em 0em' }}>
        <Card>
          <Card.Content>
            <div style={{ textAlign: 'center', marginBottom: '1em' }}>
              <Icon name='comments outline' size='massive' centered color='red'/>
            </div>
            <Card.Header>
Chat</Card.Header>
            <Card.Meta>⟨Quantum|Adviser⟩</Card.Meta>
            <Card.Description>
             Answer questions about quantum computing hardware, software, algorithms, error correction, communication, sensing, entrepreneurship, and research.
            </Card.Description>
          </Card.Content>
        </Card>

        <Card>
          <Card.Content>
            <div style={{ textAlign: 'center', marginBottom: '1em' }}>
              <Icon name='university' size='massive' centered color='orange'/>
            </div>
            <Card.Header>Research</Card.Header>
            <Card.Meta>⟨Quantum|Researcher⟩</Card.Meta>
            <Card.Description>
              Get answers from research documentation on quantum technologies, papers on quantum technology research, articles and books about quantum computing, blogs of quantum companies, people in the quantum industry, the internet, and other sources.
            </Card.Description>
          </Card.Content>
        </Card>

        <Card>
          <Card.Content>
            <div style={{ textAlign: 'center', marginBottom: '1em' }}>
              <Icon name='chart bar' size='massive' centered color='yellow'/>
            </div>
            <Card.Header>Talk Math & Physics</Card.Header>
            <Card.Meta>⟨Quantum|Formatter⟩</Card.Meta>
            <Card.Description>
              Talk math and physics.
              Chat using plain text, Markdown and MathJax.
              Answers can contain text, math, code, images, and diagrams of quantum circuits, etc.
            </Card.Description>
          </Card.Content>
        </Card>

        <Card>
          <Card.Content>
            <div style={{ textAlign: 'center', marginBottom: '1em' }}>
              <Icon name='magic' size='massive' centered color='olive'/>
            </div>
            <Card.Header>Generate</Card.Header>
            <Card.Meta>⟨Quantum|Programmer⟩</Card.Meta>
            <Card.Description>
              Generate code using quantum programming languages such as OpenQASM, Q# and quantum libraries such as Qiskit, Cirq, QCEngine, etc.
            </Card.Description>
          </Card.Content>
        </Card>

        <Card>
          <Card.Content>
            <div style={{ textAlign: 'center', marginBottom: '1em' }}>
              <Icon name='server' size='massive' centered color='green'/>
            </div>
            <Card.Header>Simulate</Card.Header>
            <Card.Meta>⟨Quantum|Simulator⟩</Card.Meta>
            <Card.Description>
              Simulate quantum circuits on web and cloud quantum simulators.
              Web simulators can simulate tens of qubits efficiently.
              IBM Cloud Simulator can run circuits with up to thousands of qubits.
            </Card.Description>
          </Card.Content>
        </Card>

        <Card>
          <Card.Content>
            <div style={{ textAlign: 'center', marginBottom: '1em' }}>
              <Icon name='react' size='massive' centered color='teal'/>
            </div>
            <Card.Header>Run on Quantum Hardware</Card.Header>
            <Card.Meta>⟨Quantum|Harware⟩</Card.Meta>
            <Card.Description>
              Execute quantum algorithms on real quantum hardware from such providers as IBM, and others.
            </Card.Description>
          </Card.Content>
        </Card>

        <Card>
          <Card.Content>
            <div style={{ textAlign: 'center', marginBottom: '1em' }}>
              <Icon name='sync' size='massive' centered color='blue'/>
            </div>
            <Card.Header>Transpile</Card.Header>
            <Card.Meta>⟨Quantum|Transpiler⟩</Card.Meta>
            <Card.Description>
              Convert quantum code between various quantum programming languages and libraries such as OpenQASM, JavaScript, Qiskit, pyQuil, Quil, Cirq, QuEST, Q#, Qiskit Qobj, TensorFlow Quantum, Braket, pyAQASM, AQASM, Quirk, etc.
            </Card.Description>
          </Card.Content>
        </Card>

        <Card>
          <Card.Content>
            <div style={{ textAlign: 'center', marginBottom: '1em' }}>
              <Icon name='rocket' size='massive' centered color='violet'/>
            </div>
            <Card.Header>Inspire</Card.Header>
            <Card.Meta>⟨Quantum|Advocate⟩</Card.Meta>
            <Card.Description>
              Advocate for using quantum computing over classical computers.
              Advance industries such as optimization, material science, music, logistics, chemistry, cybersecurity, finance, machine learning, and others.
            </Card.Description>
          </Card.Content>
        </Card>

        <Card>
          <Card.Content>
            <div style={{ textAlign: 'center', marginBottom: '1em' }}>
              <Icon name='terminal' size='massive' centered color='purple'/>
            </div>
            <Card.Header>Use API</Card.Header>
            <Card.Meta>⟨Quantum|API⟩</Card.Meta>
            <Card.Description>
              Access the ⟨Quantum|Copilot⟩ programmatically using programming languages or
              {' '}<a href='https://github.com/alphara/qcopilot-js/blob/main/API.md' target='_blank'>curl</a>.
              Get assistance from our platfrom direcly from your Jupyter Notebook or a terminal using our
              {' '}<a href='https://github.com/alphara/qcopilot-js' target='_blank'>qcopilot-js</a>{' '}
              tool.
            </Card.Description>
          </Card.Content>
        </Card>

        <Card>
          <Card.Content>
            <div style={{ textAlign: 'center', marginBottom: '1em' }}>
              <Icon name='road' size='massive' centered color='pink'/>
            </div>
            <Card.Header>Create</Card.Header>
            <Card.Meta>⟨Quantum|Creative⟩</Card.Meta>
            <Card.Description>
              There is so much more that you can do with ⟨Quantum|Copilot⟩. Run your Jupyter notebooks, draw circuits as SVG vector images, etc.
              We look forward to learn what you can do with our platform.
            </Card.Description>
          </Card.Content>
        </Card>
      </Card.Group>

      <Container text>
        <Header as='h1'>
          Program Quantum Algorithms in Plain Language
        </Header>
        <Message
          icon='talk'
          header='Input'
          content='Create a quantum circuit with 2 qubits. Apply Hadamard gate on qubit 0, then apply controlled not gate with control qubit 0 and target qubit 1. Measure all qubits. Use OpenQASM.'
        />

        <Header as='h5'>
          Cirquit Code Examples
        </Header>
        <Tab
          menu={{ pointing: true }}
          panes={ [
          { menuItem: 'OpenQASM', render: () => (
            <Tab.Pane>
              <QCMarkdown dark>
                { '```openqasm\n'
                  + '// Generated in ⟨Quantum|Copilot⟩\n'
                  + 'OPENQASM 2.0;\n'
                  + 'include "qelib1.inc";\n'
                  + 'qreg q[2];\n'
                  + 'creg c[2];\n'
                  + 'h q[0];\n'
                  + 'cx q[0], q[1];\n'
                  + 'measure q[0] -> c[0];\n'
                  + 'measure q[1] -> c[1];\n'
                  + '\n```'
                }
              </QCMarkdown>
            </Tab.Pane>
          ) },
          { menuItem: 'Qiskit', render: () => (
            <Tab.Pane>
              <QCMarkdown dark>
                { '```python\n' +
`# Generated in ⟨Quantum|Copilot⟩
from qiskit import QuantumCircuit, QuantumRegister, ClassicalRegister
from qiskit import execute, Aer
import numpy as np

backend = Aer.get_backend('qasm_simulator')

shots = 1024

qc = QuantumCircuit()

q = QuantumRegister(2, 'q')
c = ClassicalRegister(2, 'c')

qc.add_register(q)
qc.add_register(c)

qc.h(q[0])
qc.cx(q[0], q[1])
qc.measure(q[0], c[0])
qc.measure(q[1], c[1])

job = execute(qc, backend=backend, shots=shots)
job_result = job.result()
print(job_result.get_counts(qc))
`
                  + '\n```'
                }
              </QCMarkdown>
            </Tab.Pane>
          ) },
          { menuItem: 'Cirq', render: () => (
            <Tab.Pane>
              <QCMarkdown dark>
                { '```python\n' +
`# Generated in ⟨Quantum|Copilot⟩
import cirq
import numpy as np
from functools import reduce

q = [cirq.NamedQubit('q' + str(i)) for i in range(2)]

circuit = cirq.Circuit(
  cirq.H(q[0]),
  cirq.CNOT(q[0], q[1]),
  cirq.measure(q[0], key='c0'),
  cirq.measure(q[1], key='c1')
)

simulator = cirq.Simulator()
result = simulator.run(circuit, repetitions=1024)
result_dict = dict(result.multi_measurement_histogram(keys=['c0', 'c1']))
keys = list(map(lambda arr: reduce(lambda x, y: str(x) + str(y), arr[::-1]), result_dict.keys()))
counts = dict(zip(keys,[value for value in result_dict.values()]))
print(counts)
`
                  + '\n```'
                }
              </QCMarkdown>
            </Tab.Pane>
          ) },
          { menuItem: 'Q#', render: () => (
            <Tab.Pane>
              <QCMarkdown dark>
                { '```qsharp\n' +
`namespace Quantum {
  open Microsoft.Quantum.Intrinsic;
  open Microsoft.Quantum.Canon;
  open Microsoft.Quantum.Math;
  open Microsoft.Quantum.Convert;

  function SetBitValue(reg: Int, bit: Int, value: Bool): Int {
      if(value) {
          return reg ||| (1 <<< bit);
      } else {
          return reg &&& ~~~(1 <<< bit);
      }
  }

  operation Circuit() : (Int) {
      mutable c = 0;
      using(qubits = Qubit[2]) {
          H(qubits[0]);
          CNOT(qubits[0], qubits[1]);
          set c = SetBitValue(c, 0, ResultAsBool(M(qubits[0])));
          set c = SetBitValue(c, 1, ResultAsBool(M(qubits[1])));
          ResetAll(qubits);
      }
      return (c);
  }
}`
                  + '\n```'
                }
              </QCMarkdown>
            </Tab.Pane>
          ) },
          { menuItem: 'Braket', render: () => (
            <Tab.Pane>
              <QCMarkdown dark>
                { '```python\n' +
`import numpy as np
from braket.devices import LocalSimulator
from braket.circuits import Circuit
from collections import Counter

shots = 1024

circuit = Circuit()
circuit.h(0)
circuit.cnot(0, 1)
# Unsupported gate "measure".
# Unsupported gate "measure".


local_sim = LocalSimulator()
result = local_sim.run(circuit, shots=shots).result()
counts = Counter({ "".join(reversed(k)): v for k, v in result.measurement_counts.items() })

print(counts)
`
                  + '\n```'
                }
              </QCMarkdown>
            </Tab.Pane>
          ) },
          { menuItem: 'QuEST', render: () => (
            <Tab.Pane>
              <QCMarkdown dark>
                { '```cpp\n' +
`// Generated in ⟨Quantum|Copilot⟩
#include <math.h>
#include "QuEST.h"

#ifndef M_PI
#define M_PI 3.14159265
#endif

int main(int argc, char *argv[]) {
  QuESTEnv env = createQuESTEnv();
  Qureg qubits = createQureg(2, env);
  int measured[2];


  hadamard(qubits, 0);
  controlledNot(qubits, 0, 1);
  measured[0] = measure(qubits, 0);
  measured[1] = measure(qubits, 1);

  destroyQureg(qubits, env);
  destroyQuESTEnv(env);
  return 0;
}
`
                  + '\n```'
                }
              </QCMarkdown>
            </Tab.Pane>
          ) },
          { menuItem: 'Quil', render: () => (
            <Tab.Pane>
              <QCMarkdown dark>
                { '```python\n' +
`# Generated in ⟨Quantum|Copilot⟩

DECLARE ro BIT[2]
H 0
CNOT 0 1
MEASURE 0 ro[0]
MEASURE 1 ro[1]
`
                  + '\n```'
                }
              </QCMarkdown>
            </Tab.Pane>
          ) },
          { menuItem: 'AQASM', render: () => (
            <Tab.Pane>
              <QCMarkdown dark>
                { '```python\n' +
`BEGIN
qubits 2
cbits 2
H q[0]
CNOT q[0], q[1]
MEAS q[0], c[0]
MEAS q[1], c[1]
END
`
                  + '\n```'
                }
              </QCMarkdown>
            </Tab.Pane>
          ) },
          { menuItem: 'JavaScript', render: () => (
            <Tab.Pane>
              <QCMarkdown dark>
                { '```javascript\n' +
`// Generated in ⟨Quantum|Copilot⟩
const QuantumCircuit = require("quantum-circuit");

const circuit = new QuantumCircuit(2);

circuit.createCreg("c", 2);

circuit.appendGate("h", 0, {});
circuit.appendGate("cx", [0,1], {});
circuit.addMeasure(0, "c", 0);
circuit.addMeasure(1, "c", 1);

circuit.run();

console.log("Probabilities:");
console.log(JSON.stringify(circuit.probabilities()));

console.log("Measure all:");
console.log(JSON.stringify(circuit.measureAll()));

console.log("Classical registers:");
console.log(circuit.cregsAsString());
`
                  + '\n```'
                }
              </QCMarkdown>
            </Tab.Pane>
          ) },
        ] } />

        <Header as='h5' secondary>
          Circuit Image Examples
        </Header>
        <Tab
          menu={{ pointing: true }}
          panes={ [
          { menuItem: 'SVG', render: () => (
            <Tab.Pane>
              <Segment attached>
                <svg class="qc-circuit" width="340" height="256" version="1.1" xmlns="http://www.w3.org/2000/svg"><text class="qc-wire-init" x="0" y="54" dominant-baseline="middle" text-anchor="start">|0&#x27E9;</text><line class="qc-wire" x1="20" x2="340" y1="54" y2="54" stroke="black" stroke-width="1" /><text class="qc-wire-label" x="20" y="38" dominant-baseline="hanging" text-anchor="start" font-size="75%">q0</text><text class="qc-wire-init" x="0" y="128" dominant-baseline="middle" text-anchor="start">|0&#x27E9;</text><line class="qc-wire" x1="20" x2="340" y1="128" y2="128" stroke="black" stroke-width="1" /><text class="qc-wire-label" x="20" y="112" dominant-baseline="hanging" text-anchor="start" font-size="75%">q1</text><text class="qc-wire-init" x="0" y="202" dominant-baseline="middle" text-anchor="start">0</text><line class="qc-wire-c" x1="20" x2="340" y1="202" y2="202" stroke="silver" stroke-width="1" /><text class="qc-wire-label" x="20" y="186" dominant-baseline="hanging" text-anchor="start" font-size="75%">c</text><g class="qc-gate-group" data-id="E9ak2NX6ZiBTMKnKQQ" data-gate="h"><rect class="qc-gate-box" x="68" y="34" width="40" height="40" stroke="black" fill="white" stroke-width="1" /><text class="qc-gate-label" x="88" y="54" dominant-baseline="middle" text-anchor="middle" fill="black">H</text><text class="qc-gate-params" x="88" y="80" dominant-baseline="hanging" text-anchor="middle" font-size="75%"></text></g><g class="qc-gate-group" data-id="oDu8rOlQdo1HjyT7Wv" data-gate="cx"><line class="qc-gate-link" x1="156" x2="156" y1="54" y2="128" stroke="black" stroke-width="1" /><circle class="qc-gate-dot" cx="156" cy="54" r="5" stroke="black" fill="black" stroke-width="1" /><ellipse class="qc-gate-not" cx="156" cy="128" rx="16" ry="16" stroke="black" fill="white" stroke-width="1" /><line class="qc-gate-not-line" x1="156" x2="156" y1="112" y2="144" stroke="black" stroke-width="1" /><line class="qc-gate-not-line" x1="140" x2="172" y1="128" y2="128" stroke="black" stroke-width="1" /><text class="qc-gate-params" x="156" y="154" dominant-baseline="hanging" text-anchor="middle" font-size="75%"></text></g><g class="qc-gate-group" data-id="IeEamX529r6cUUlc5n" data-gate="measure"><rect class="qc-gate-box" x="204" y="34" width="40" height="40" stroke="black" fill="white" stroke-width="1" /><path class="gc-gate-gauge-arc" d="M 239.06131137016416 53.30434782608695 A 17.39130434782609 17.39130434782609 0 0 0 208.93868862983584 53.30434782608695" stroke="black" fill="none" stroke-width="1" /><line class="qc-gate-gauge-scale" x1="224" x2="236" y1="62" y2="42" stroke="black" stroke-width="1" /><line class="qc-gate-link-c" x1="224" x2="224" y1="74" y2="202" stroke="silver" stroke-width="1" /><line class="qc-gate-link-c" x2="224" x1="219" y1="192" y2="202" stroke="silver" stroke-width="1" /><line class="qc-gate-link-c" x2="224" x1="229" y1="192" y2="202" stroke="silver" stroke-width="1" /><text class="qc-wire-label" x="224" y="210" dominant-baseline="hanging" text-anchor="middle" font-size="75%">0</text></g><g class="qc-gate-group" data-id="RRWLWCXZBZ5Y82pITW" data-gate="measure"><rect class="qc-gate-box" x="272" y="108" width="40" height="40" stroke="black" fill="white" stroke-width="1" /><path class="gc-gate-gauge-arc" d="M 307.06131137016416 127.30434782608695 A 17.39130434782609 17.39130434782609 0 0 0 276.93868862983584 127.30434782608695" stroke="black" fill="none" stroke-width="1" /><line class="qc-gate-gauge-scale" x1="292" x2="304" y1="136" y2="116" stroke="black" stroke-width="1" /><line class="qc-gate-link-c" x1="292" x2="292" y1="148" y2="202" stroke="silver" stroke-width="1" /><line class="qc-gate-link-c" x2="292" x1="287" y1="192" y2="202" stroke="silver" stroke-width="1" /><line class="qc-gate-link-c" x2="292" x1="297" y1="192" y2="202" stroke="silver" stroke-width="1" /><text class="qc-wire-label" x="292" y="210" dominant-baseline="hanging" text-anchor="middle" font-size="75%">1</text></g></svg>
              </Segment>
            </Tab.Pane>
          ) },
          { menuItem: 'TextDrawing', render: () => (
            <Tab.Pane>
              <pre>{
`
     ┌───┐     ┌─┐   
q_0: ┤ H ├──■──┤M├───
     └───┘┌─┴─┐└╥┘┌─┐
q_1: ─────┤ X ├─╫─┤M├
          └───┘ ║ └╥┘
c: 2/═══════════╩══╩═
              0  1 
`
              }</pre>
            </Tab.Pane>
          ) },
          { menuItem: 'Quirk', render: () => (
            <Tab.Pane>
              <Segment attached>
                <iframe
                  title='JupyterLite IFrame'
                  src='/quirk/quirk.html#circuit=%7B%22cols%22%3A%5B%5B%22H%22%5D%2C%5B%22%E2%80%A2%22%2C%22X%22%5D%5D%7D'
                  width="100%"
                  height="500px"
                >
                </iframe>
              </Segment>
            </Tab.Pane>
          ) },
          { menuItem: 'Matplotlib 🔜', render: () => (
            <Tab.Pane>
              <Image src={'data:image/png;base64, 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'} />
            </Tab.Pane>
          ) },
          { menuItem: 'LaTeX 🔜', render: () => (
            <Tab.Pane>
              <Segment attached>
                <Image src={'data:image/png;base64, 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'} />
              </Segment>
            </Tab.Pane>
          ) },
          { menuItem: 'LaTeX Source 🔜', render: () => (
            <Tab.Pane>
              <QCMarkdown dark>
                {'\\documentclass[border=2px]{standalone}\n\n\\usepackage[braket, qm]{qcircuit}\n\\usepackage{graphicx}\n\n\\begin{document}\n\\scalebox{1.0}{\n\\Qcircuit @C=1.0em @R=0.2em @!R { \\\\\n\t \t\\nghost{{q}_{0} :  } & \\lstick{{q}_{0} :  } & \\gate{\\mathrm{H}} & \\ctrl{1} & \\meter & \\qw & \\qw & \\qw\\\\\n\t \t\\nghost{{q}_{1} :  } & \\lstick{{q}_{1} :  } & \\qw & \\targ & \\qw & \\meter & \\qw & \\qw\\\\\n\t \t\\nghost{\\mathrm{{c} :  }} & \\lstick{\\mathrm{{c} :  }} & \\lstick{/_{_{2}}} \\cw & \\cw & \\dstick{_{_{\\hspace{0.0em}0}}} \\cw \\ar @{<=} [-2,0] & \\dstick{_{_{\\hspace{0.0em}1}}} \\cw \\ar @{<=} [-1,0] & \\cw & \\cw\\\\\n\\\\ }}\n\\end{document}' }
              </QCMarkdown>
            </Tab.Pane>
          ) },
        ] } />
      </Container>

      <Container style={{ marginTop: '6em' }}>
        <Divider
          as='h4'
          className='header'
          horizontal
          style={{ margin: '3em 0em', textTransform: 'uppercase' }}
        >
          <a href='#'>
            Demo Video
          </a>
        </Divider>
        <Embed
          id='1FxJ4kelZvw'
          placeholder='/images/demo-placeholder.png'
          source='youtube'
        />
      </Container>

      <Segment style={{ padding: '3em 0em' }} vertical>
        <Container text>
          <Divider
            as='h4'
            className='header'
            horizontal
            style={{ margin: '3em 0em', textTransform: 'uppercase' }}
          >
            <a href='#'>
              Quantum future is here
            </a>
          </Divider>
          <p style={{ fontSize: '1.33em' }}>
            {/*
            Sign up for a free trial today and start exploring the power of quantum computing!
            */}
            Start exploring <i>powerful</i> conversations about of <i>quantum computing</i>!
          </p>
          <Button size='large' color='teal' onClick={() => logIn(false)}>
            { available ? 'Get Started Today' : 'Join a Whitelist' }
            <Icon name='right arrow' />
          </Button>
        </Container>
      </Segment>

      <Segment inverted vertical style={{ padding: '5em 0em' }}>
        <Container>
          <Grid divided inverted stackable>
            <Grid.Row>
              <Grid.Column width={3}>
                <Header inverted as='h4' content='About' />
                <List link inverted>
                  <List.Item as='a'>
                    <a href='mailto:admin@vuics.com'>
                      Contact Us
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://www.linkedin.com/showcase/quantum-copilot/' target='_blank' rel='noopener noreferrer'>
                      Follow on LinkedIn
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://youtube.com/playlist?list=PLXkNXBn6_PqxAFUWetX0_r7825eVMJTAs&si=hdD6MJ1Fo7MSHicc' target='_blank' rel='noopener noreferrer'>
                      Subscribe on YouTube
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://www.producthunt.com/posts/quantum-copilot' target='_blank' rel='noopener noreferrer'>
                      Upvote on ProductHunt
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://vuics.tawk.help/category/quantum-copilot' target='_blank' rel='noopener noreferrer'>
                      Knowledge Base
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://vuics.tawk.help/article/quantum-copilot-faq' target='_blank' rel='noopener noreferrer'>
                      FAQ
                    </a>
                  </List.Item>
                </List>
              </Grid.Column>
              <Grid.Column width={5}>
                <Header inverted as='h4' content='Services' />
                <List link inverted>
                  <List.Item as='a'>
                    <a href='https://qc.vuics.com/' target='_blank' rel='noopener noreferrer'>
                      Quantum Copilot
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://quantum-gpt.vuics.com/' target='_blank' rel='noopener noreferrer'>
                      Quantum GPT
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://vuics.com' target='_blank' rel='noopener noreferrer'>
                      Voice User Interfaces
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <Divider />
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://cs.vuics.com' target='_blank' rel='noopener noreferrer'>
                      Contract Smarter
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://jf.vuics.com' target='_blank' rel='noopener noreferrer'>
                      Joke Funnier
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://qt.vuics.com' target='_blank' rel='noopener noreferrer'>
                      Quantum Trading Fund
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://hc.vuics.com' target='_blank' rel='noopener noreferrer'>
                      Hypno-Coaching
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://qm.vuics.com' target='_blank' rel='noopener noreferrer'>
                      TchaiQovsky: Quantum Music
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://db.vuics.com' target='_blank' rel='noopener noreferrer'>
                      Your Own Decentalized Bank
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://sf.vuics.com' target='_blank' rel='noopener noreferrer'>
                      Open-Source: Survival For
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <Divider />
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://qcohorte.org/' target='_blank' rel='noopener noreferrer'>
                      Q cohorté
                    </a>
                  </List.Item>
                </List>
              </Grid.Column>
              <Grid.Column width={7}>
                <List link inverted>
                  <List.Item as='a'>
                    <p>
                      Quantum computing for everyone every day.
                    </p>
                  </List.Item>
                  <List.Item as='a'>
                    <p>
                      © 2023 Vuics. All rights reserved.
                    </p>
                  </List.Item>
                </List>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </Segment>
    </ResponsiveContainer>
  )
}

export default HomepageLayout
